import React from "react";
import Autocomplete from "react-google-autocomplete";
import { GOOGLE_MAPS_APIKEY } from "../../config/Apis";
import styles from "./AutoCompleteInput.module.css";

const AutoCompleteInput = ({
  address,
  placeholder,
  label,
  onSelectPlace,
  style,
  className,
  onChange
}) => {
  return (
    <div className={`${styles.Label} ${className}`} style={style}>
      <label>{label}</label>
      <div className={styles.input}>
        <Autocomplete
          // apiKey={GOOGLE_MAPS_APIKEY}
          defaultValue={address}

          className={styles.innerInput}
          placeholder={placeholder ? placeholder : "Enter Address"}
          onPlaceSelected={(place) => {
            onSelectPlace(place);
          }}
          options={{
            types: ["geocode", "establishment"],
          }}
          language={"en"}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default AutoCompleteInput;
// let currentLocation = {
//     lat: place?.geometry?.location?.lat(),
//     lng: place?.geometry?.location?.lng(),
//     address: place?.formatted_address,
//   };
//   setCurrentLocation(currentLocation);
